var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlerts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 62,
    viewBox: "0 0 206 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2134_114220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6748 0.969229C8.6748 0.433937 9.10874 0 9.64404 0H11.5825C12.1178 0 12.5517 0.433939 12.5517 0.969231V62.9224H8.6748V0.969229Z",
    fill: "#3D3D3D",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6748 37.0513C8.6748 36.516 9.10874 36.082 9.64404 36.082H11.5825C12.1178 36.082 12.5517 36.516 12.5517 37.0513V63.0002H8.6748V37.0513Z",
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.6748,
    y: 47.4922,
    width: 3.87692,
    height: 9.20769,
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6748 56.708H12.5517V63.0002H8.6748V56.708Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0518 0.969229C24.0518 0.433937 24.4857 0 25.021 0H26.9595C27.4947 0 27.9287 0.433939 27.9287 0.969231V62.9224H24.0518V0.969229Z",
    fill: "#3D3D3D",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0518 16.4331C24.0518 15.8978 24.4857 15.4639 25.021 15.4639H26.9595C27.4947 15.4639 27.9287 15.8978 27.9287 16.4331V63.0002H24.0518V16.4331Z",
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.0518,
    y: 53.2637,
    width: 3.87692,
    height: 8.01818,
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0518 61.2817H27.9287V62.9999H24.0518V61.2817Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4287 0.969229C39.4287 0.433937 39.8627 0 40.3979 0H42.3364C42.8717 0 43.3056 0.433939 43.3056 0.969231V62.9224H39.4287V0.969229Z",
    fill: "#3D3D3D",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4287 21.5874C39.4287 21.0521 39.8627 20.6182 40.3979 20.6182H42.3364C42.8717 20.6182 43.3056 21.0521 43.3056 21.5874V63H39.4287V21.5874Z",
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.4287,
    y: 29.7817,
    width: 3.87692,
    height: 33.2182,
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8057 0.969229C54.8057 0.433937 55.2396 0 55.7749 0H57.7134C58.2486 0 58.6826 0.433939 58.6826 0.969231V62.9224H54.8057V0.969229Z",
    fill: "#3D3D3D",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8057 37.0513C54.8057 36.516 55.2396 36.082 55.7749 36.082H57.7134C58.2486 36.082 58.6826 36.516 58.6826 37.0513V63.0002H54.8057V37.0513Z",
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.8057,
    y: 47.4922,
    width: 3.87692,
    height: 9.20769,
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8057 56.708H58.6826V63.0002H54.8057V56.708Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1826 0.969229C70.1826 0.433937 70.6166 0 71.1518 0H73.0903C73.6256 0 74.0595 0.433939 74.0595 0.969231V62.9224H70.1826V0.969229Z",
    fill: "#3D3D3D",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1826 37.0513C70.1826 36.516 70.6166 36.082 71.1518 36.082H73.0903C73.6256 36.082 74.0595 36.516 74.0595 37.0513V63.0002H70.1826V37.0513Z",
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.1826,
    y: 47.4922,
    width: 3.87692,
    height: 9.20769,
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1826 56.708H74.0595V63.0002H70.1826V56.708Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5596 0.969229C85.5596 0.433937 85.9935 0 86.5288 0H88.4673C89.0026 0 89.4365 0.433939 89.4365 0.969231V62.9224H85.5596V0.969229Z",
    fill: "#3D3D3D",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5596 24.4512C85.5596 23.9159 85.9935 23.4819 86.5288 23.4819H88.4673C89.0026 23.4819 89.4365 23.9159 89.4365 24.4512V63.0001H85.5596V24.4512Z",
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.5596,
    y: 34.3638,
    width: 3.87692,
    height: 22.3364,
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5596 44.6729H89.4365V63.0001H85.5596V44.6729Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.937 0.969229C100.937 0.433937 101.37 0 101.906 0H103.844C104.38 0 104.813 0.433939 104.813 0.969231V62.9224H100.937V0.969229Z",
    fill: "#3D3D3D",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.937 37.0513C100.937 36.516 101.37 36.082 101.906 36.082H103.844C104.38 36.082 104.813 36.516 104.813 37.0513V63.0002H100.937V37.0513Z",
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.937,
    y: 47.4922,
    width: 3.87692,
    height: 9.20769,
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.937 56.708H104.813V63.0002H100.937V56.708Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.313 1.93846C116.313 0.867879 117.181 0 118.252 0C119.323 0 120.19 0.867879 120.19 1.93846V62.9224H116.313V1.93846Z",
    fill: "#3D3D3D",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.313 0H120.19V63H116.313V0Z",
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.313,
    y: 22.7769,
    width: 3.87692,
    height: 40.2231,
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.313 56.708H120.19V63.0002H116.313V56.708Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69 0.969229C131.69 0.433937 132.124 0 132.659 0H134.598C135.133 0 135.567 0.433939 135.567 0.969231V62.9224H131.69V0.969229Z",
    fill: "#3D3D3D",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69 37.0513C131.69 36.516 132.124 36.082 132.659 36.082H134.598C135.133 36.082 135.567 36.516 135.567 37.0513V63.0002H131.69V37.0513Z",
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.69,
    y: 47.4922,
    width: 3.87692,
    height: 9.20769,
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69 56.708H135.567V63.0002H131.69V56.708Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.067 0.969229C147.067 0.433937 147.501 0 148.036 0H149.975C150.51 0 150.944 0.433939 150.944 0.969231V62.9224H147.067V0.969229Z",
    fill: "#3D3D3D",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.067 24.4512C147.067 23.9159 147.501 23.4819 148.036 23.4819H149.975C150.51 23.4819 150.944 23.9159 150.944 24.4512V63.0001H147.067V24.4512Z",
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.067,
    y: 34.3638,
    width: 3.87692,
    height: 22.3364,
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.067 44.6729H150.944V63.0001H147.067V44.6729Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.444 0.969229C162.444 0.433937 162.878 0 163.413 0H165.352C165.887 0 166.321 0.433939 166.321 0.969231V62.9224H162.444V0.969229Z",
    fill: "#3D3D3D",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.444 16.4331C162.444 15.8978 162.878 15.4639 163.413 15.4639H165.352C165.887 15.4639 166.321 15.8978 166.321 16.4331V63.0002H162.444V16.4331Z",
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.444,
    y: 53.2637,
    width: 3.87692,
    height: 8.01818,
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.444 61.2817H166.321V62.9999H162.444V61.2817Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.821 0.969229C177.821 0.433937 178.255 0 178.79 0H180.729C181.264 0 181.698 0.433939 181.698 0.969231V62.9224H177.821V0.969229Z",
    fill: "#3D3D3D",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.821 37.0513C177.821 36.516 178.255 36.082 178.79 36.082H180.729C181.264 36.082 181.698 36.516 181.698 37.0513V63.0002H177.821V37.0513Z",
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.821,
    y: 47.4922,
    width: 3.87692,
    height: 9.20769,
    fill: "#FEDF1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.821 56.708H181.698V63.0002H177.821V56.708Z",
    fill: "#FB6C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.198 0.969229C193.198 0.433937 193.632 0 194.167 0H196.106C196.641 0 197.075 0.433939 197.075 0.969231V62.9224H193.198V0.969229Z",
    fill: "#3D3D3D",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.198 25.5967C193.198 25.0614 193.632 24.6274 194.167 24.6274H196.106C196.641 24.6274 197.075 25.0614 197.075 25.5967V63.0002H193.198V25.5967Z",
    fill: "#78D608"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.198 41.2363H197.075V63H193.198V41.2363Z",
    fill: "#FB6C4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2134_114220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 62,
    fill: "white",
    transform: "translate(0.375)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/alerts.cff340edb8299fd8570e9be2c06564d1.svg";
export { ForwardRef as ReactComponent };